import { render, staticRenderFns } from "./SchemeWorker.vue?vue&type=template&id=cbce806a&scoped=true&"
import script from "./SchemeWorker.vue?vue&type=script&lang=js&"
export * from "./SchemeWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce806a",
  null
  
)

export default component.exports